// import VbChoXuLyIndex from "../views/doc-out/VbChoXuLyIndex.vue";
// import VbDaXuLyIndex from "../views/doc-out/VbDaXuLyIndex.vue";
// import VbNhanDeBietIndex from "../views/doc-out/VbNhanDeBietIndex.vue";
// import VbThuHoiIndex from "../../../views/doc-out/VbThuHoiIndex.vue";
import VbDaBanHanhIndex from "../views/doc-out/VbDaBanHanhIndex.vue";
import VbChoBanHanhIndex from "../views/doc-out/VbChoBanHanhIndex.vue";
// import VbDuThaoIndex from "../views/doc-out/Index.vue";
import VbDuThaoNewIndex from "../views/doc-out/NewIndex.vue";
import VbDaPhatHanhNewIndex from "../views/doc-out/VbDaPhatHanhNewIndex.vue";

export default [

  // văn bản dự thảo (new)
  {
    path: "/app/:userDeptRoleId/vbDuThaoNew",
    name: "vbDuThaoNew",
    component: VbDuThaoNewIndex
  },

  {
    path: "/app/:userDeptRoleId/vbDuThaoNew/edit/:id",
    name: "vbDuThaoNewEdit",
    components: {
      default: () => import("../views/doc-out/NewIndex.vue"),
      detail: () => import("../views/doc-out/VbDuThaoEdit")
    }
  },

  {
    path: "/app/:userDeptRoleId/vbChoBanHanh/detail/:id/hieuChinh",
    name: "vbChoBanHanhHieuChinh",
    components: {
      default: VbChoBanHanhIndex,
      detail: () => import("../views/doc-out/Detail.vue"),
      detail2: () => import("../views/doc-out/HieuChinh")
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDuThaoNew/detail/:id",
    name: "vbDuThaoNewDetail",
    components: {
      default: () => import("../views/doc-out/NewIndex.vue"),
      detail: () => import("../views/doc-out/Detail.vue")
    }
  },
  // ======================================== //

  // văn bản đã phát hành (new)
  {
    path: "/app/:userDeptRoleId/vbDaPhatHanhNew",
    name: "vbDaPhatHanhNew",
    component: VbDaPhatHanhNewIndex
  },

  {
    path: "/app/:userDeptRoleId/vbDaPhatHanhNew/detail/:id",
    name: "vbDaPhatHanhNewDetail",
    components: {
      default: VbDaPhatHanhNewIndex,
      detail: () => import("../views/doc-out/Detail.vue")
    }
  },
  // ======================================== //
  //
  //
  // {
  //   path: "/app/:userDeptRoleId/vbDuThao",
  //   name: "vbDuThao",
  //   component: VbDuThaoIndex
  // },
  // {
  //   path: "/app/:userDeptRoleId/vbDuThao/edit/:id",
  //   name: "vbDuThaoEdit",
  //   components: {
  //     default: () => import("../views/doc-out/Index.vue"),
  //     detail: () => import("../views/doc-out/Detail.vue")
  //   }
  // },
  //
  // {
  //   path: "/app/:userDeptRoleId/vbDuThao/detail/:id",
  //   name: "vbDuThaoDetail",
  //   components: {
  //     default: () => import("../views/doc-out/Index.vue"),
  //     detail: () => import("../views/doc-out/Detail.vue")
  //   }
  // },

  // {
  //   path: "/app/:deptCode/:roleCode/vbDuThao/create",
  //   name: "vbDuThaoCreate",
  //   components: {
  //     default: () => import("../../../views/doc-out/Index"),
  //     detail: () => import("@/views/doc-out/Create")
  //   }
  // },
  // {
  //   path: "/app/:deptCode/:roleCode/vbDuThao/detail/:id",
  //   name: "vbDuThaoDetail",
  //   components: {
  //     default: () => import("../../../views/doc-out/Index"),
  //     detail: () => import("@/views/doc-out/Detail")
  //   }
  // },

  // // cho xu li;
  // {
  //   path: "/app/:userDeptRoleId/vbChoXuLi",
  //   name: "vbChoXuLi",
  //   component: VbChoXuLyIndex
  // },
  // {
  //   path: "/app/:userDeptRoleId/vbChoXuLi/detail/:id",
  //   name: "vbChoXuLiDetail",
  //   components: {
  //     default: VbChoXuLyIndex,
  //     detail: () => import("../views/doc-out/Detail.vue")
  //   }
  // },
  // //===================Da xu ly================
  // {
  //   path: "/app/:userDeptRoleId/vbDaXuLy",
  //   name: "vbDaXuLy",
  //   component: VbDaXuLyIndex
  // },

  // {
  //   path: "/app/:deptCode/vbDaXuLy/detail/:id",
  //   name: "vbDaXuLyDetail",
  //   components: {
  //     default: VbDaXuLyIndex,
  //     detail: Detail
  //   }
  // },
  // //===================Nhan de biet================
  // {
  //   path: "/app/:userDeptRoleId/vbNhanDeBiet",
  //   name: "vbNhanDeBietIndex",
  //   component: VbNhanDeBietIndex
  // },
  // {
  //   path: "/app/:userDeptRoleId/detail/:id",
  //   name: "vbNhanDeBietDetail",
  //   components: {
  //     default: VbNhanDeBietIndex,
  //     detail: Detail
  //   }
  // },
  // //===================Thu hoi================
  // {
  //   path: "/app/:deptCode/:roleCode/vbThuHoi",
  //   name: "vbThuHoi",
  //   component: VbThuHoiIndex
  // },
  // {
  //   path: "/app/:deptCode/vbThuHoi/detail/:id",
  //   name: "vbThuHoiDetail",
  //   component: {
  //     default: VbThuHoiIndex,
  //     detail: Detail
  //   }
  // },
  // //===================Cho ban hanh================
  {
    path: "/app/:userDeptRoleId/vbChoBanHanh",
    name: "vbChoBanHanh",
    component: VbChoBanHanhIndex
  },
  {
    path: "/app/:userDeptRoleId/vbChoBanHanh/detail/:id",
    name: "vbChoBanHanhDetail",
    components: {
      default: VbChoBanHanhIndex,
      detail: () => import("../views/doc-out/Detail.vue")
    }
  },
  // //===================Da ban hanh================
  {
    path: "/app/:userDeptRoleId/vbDaBanHanh",
    name: "vbDaBanHanh",
    component: VbDaBanHanhIndex
  },
  {
    path: "/app/:userDeptRoleId/vbDaBanHanh/detail/:id",
    name: "vbDaBanHanhDetail",
    components: {
      default: VbDaBanHanhIndex,
      detail: () => import("../views/doc-out/Detail.vue")
    }
  },
  // //============Quangnd start============
  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSo/",
    name: "vbDiDaVaoSo",
    component: () => import("../views/doc-out/vbDiDaVaoSoIndex.vue")
  },

  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSo/detail/:id",
    name: "vbDiDaVaoSoDetail",
    components: {
      default: () => import("../views/doc-out/vbDiDaVaoSoIndex.vue"),
      detail: () => import("../views/doc-out/Detail.vue")
    },
  }
  // //============Quangnd end============
];



// WEBPACK FOOTER //
// ./src/router/document-out.js